import { useState } from "react";
import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import AlertForm from "./../../Forms/AlertForm/AlertForm";

const AlertModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:alert.detailsAlert"), error: false },
    { title: t("global:alert.assignAlert"), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "AlertForm";
  const { handleHide, show, header } = props;

  const buttons = () => {
    return (
      <>
        <BMXButton
          type="subbmit"
          data-cy="saveAlert"
          bmxclass="Success"
          onClick={() => setIsSubmit(true)}
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"800px"}
      height={"600px"}
      onClose={handleHide}
      buttons={buttons()}
      steps={steps}
      header={header}
    >
      <AlertForm
        steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        formName={formName}
        handleHide={handleHide}
        setErrorHeader={setErrorHeader}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "AlertModal" })(AlertModal);
